import React from "react"
import { AdderTypes, dollarsToNum } from "@oneethos/shared"
import { DollarsInput, TextInput } from "./forms"
import './system-detail-inputs.scss'
import Tooltip from "./tooltip"
import { IoIosInformationCircleOutline } from "react-icons/io"

const TotalCostsSummary = ({ systemCost, loanAmount, formData, handleChange, disabled }) => {
  return (
    <div className="totals-wrapper">
      <div className="form-group">
        <label><b className='text-dark'>Total System Cost</b></label>
        <TextInput value={systemCost} disabled />
      </div>
      <div className="adders-container">
        <div className="form-group">
          <div className="d-flex gap-1">
            <label>{AdderTypes.RebatesAndOrCredits} </label>
            <Tooltip text="Enter any direct incentives or rebates. This does not include the Investment Tax Credit.">
              <IoIosInformationCircleOutline style={{ marginBottom: '5px' }} />
            </Tooltip>
          </div>
          <DollarsInput
            placeholder="$0.00"
            emptyOk
            disabled={disabled}
            before="-"
            value={formData.adders?.find(a =>
              a.description === AdderTypes.RebatesAndOrCredits)?.amount}
            onChange={v => {
              const rebatesAndOrCreditsAdder = formData.adders?.find(a =>
                a.description === AdderTypes.RebatesAndOrCredits)
              handleChange({
                ...formData,
                adders: [
                  ...(formData?.adders?.filter(a =>
                    a.description !== AdderTypes.RebatesAndOrCredits) || []),
                  {
                    description: AdderTypes.RebatesAndOrCredits,
                    amount: v,
                    notes: rebatesAndOrCreditsAdder?.notes || ''
                  }
                ]
              })
            }}
            extraValidator={(value) => {
              const rebatesAndOrCreditsAmount = dollarsToNum(value)
              const systemCostAmount = dollarsToNum(systemCost)
              return rebatesAndOrCreditsAmount <= systemCostAmount
                ? ''
                : "Value can't be more than total system cost"
            }}
          />
        </div>
        <div className="form-group">
          <label>Incentives/Rebates Description</label>
          <TextInput
            emptyOk
            value={formData.adders?.find(a =>
              a.description === AdderTypes.RebatesAndOrCredits)?.notes || ''}
            onChange={v => {
              const rebatesAndOrCreditsAdder = formData.adders?.find(a =>
                a.description === AdderTypes.RebatesAndOrCredits)
              handleChange({
                ...formData,
                adders: [
                  ...(formData?.adders?.filter(a =>
                    a.description !== AdderTypes.RebatesAndOrCredits) || []),
                  {
                    description: AdderTypes.RebatesAndOrCredits,
                    amount: rebatesAndOrCreditsAdder?.amount || 0,
                    notes: v
                  }
                ]
              })
            }}
          />
        </div>
      </div>
      <div className="form-group">
        <label>{AdderTypes.Downpayment}</label>
        <DollarsInput
          placeholder="$0.00"
          emptyOk
          disabled={disabled}
          before="-"
          value={formData.adders?.find(a =>
            a.description === AdderTypes.Downpayment)?.amount}
          onChange={v => handleChange({
            ...formData,
            adders: [
              ...(formData?.adders?.filter(a =>
                a.description !== AdderTypes.Downpayment) || []),
              { description: AdderTypes.Downpayment, amount: v }
            ]
          })}
          extraValidator={(value) => {
            const downpaymentAmount = dollarsToNum(value)
            const systemCostAmount = dollarsToNum(systemCost)
            return downpaymentAmount <= systemCostAmount
              ? ''
              : "Value can't be more than total system cost"
          }}
        />
      </div>
      <div className="form-group">
        <label><b className='text-dark'>Requested Loan Amount</b></label>
        <TextInput value={loanAmount} disabled />
      </div>
    </div>
  )
}

export default TotalCostsSummary